import React from 'react';
import type { ReactNode } from 'react';
import { presentationTableProps } from './table';

export function rowHitShell(node: ReactNode) {
  const tableProps = presentationTableProps();
  return (
    <table
      {...tableProps}
      className={'email-builder-row-hit-shell'}
      style={{
        ...tableProps.style,
        width: '100%',
      }}>
      <tbody>
        <tr>
          <td align="center">{node}</td>
        </tr>
      </tbody>
    </table>
  );
}
